module.exports = __webpack_public_path__ + "img/logo-brmania-branco.d9162344.png";